var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isContractor
    ? _c(
        "button",
        {
          staticClass:
            "px-8 py-2 text-16 rounded-full border border-secondary-black hover:bg-gray-50 focus:outline-none",
          on: {
            click: function ($event) {
              return _vm.$emit("edit")
            },
          },
        },
        [_vm._v(" Edit ")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }